import {FileEntry} from '@ionic-native/file';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {Base64FileInterface} from '../models/base64File/base64File.interface';
import { Subscriber } from 'rxjs/Subscriber';

@Injectable()
export class Base64Parser {

  public parse(fileEntry: FileEntry): Observable<{base64File: Base64FileInterface, file: File}> {

    return new Observable<{base64File: Base64FileInterface, file: File}>((observer) => {
      fileEntry.file(file => {
        this.readFile(file as any, file.name, observer);
      });
    });
  }
  private readFile(file: File, name: string, observer: Subscriber<{base64File: Base64FileInterface, file: File}>): void {
    // Read file content
    const reader = new FileReader();
    // This returns a base64 string
    reader.onloadend = () => {
      const base64File: Base64FileInterface = {nomFichier: name, mimetype: file.type, content: reader.result as any};
      observer.next({base64File: base64File, file: file});
      observer.complete();
    };
    reader.readAsDataURL(file);
  }

  public parseFile(file: File): Observable<{base64File: Base64FileInterface, file: File}> {

    return new Observable<{base64File: Base64FileInterface, file: File}>((observer) => {

      this.readFile(file, file.name, observer);
    });
  }
}



// WEBPACK FOOTER //
// ./src/shared/services/base64Parser.service.ts